import React, { PropsWithChildren, ReactElement } from 'react';

import { TLabelProperties } from './label.types';
import { StyledLabel } from './label.styled';

/**
 * A label isn't used on it's own, it's used as part of an input "molecule".
 */
export function Label({
    children,
    id,
    className,
    marginBottom = true,
}: PropsWithChildren<TLabelProperties>): ReactElement | null {
    if (!children) {
        return null;
    }

    return (
        <StyledLabel
            htmlFor={id}
            id={`label-for-${id}`}
            className={className}
            marginBottom={marginBottom}
        >
            {children}
        </StyledLabel>
    );
}
